<template>
  <div class="form-lower entry thanks">
    <section class="wrapper">
      <div class="form_ttl">
        <h1><img src="@/assets/img/client/logo.png" alt="GLOCALY"></h1>
      </div>
      <h2>{{ $t('退会手続きが完了しました') }} </h2>
      <p class="center" v-html="$t('GLOCALYをご利用いただきありがとうございました')"></p>
        <p class="loginBtn">
          <a :href="glocalyTopUrl" class="white_btn">GLOCALY TOP</a>
        </p>
    </section>
  </div>
</template>

<script>
export default {
  computed: {
    glocalyTopUrl () {
      let lang = this.$route.params.lang
      if (lang === 'ja') lang = ''
      return `https://glocaly.tokyo/${lang}`
    }
  }
}
</script>
